import React from 'react';
import PropTypes from 'prop-types';

import {Divider, Stack} from 'views/components';

import NewMessageHeader from './new_message_header/NewMessageHeader';
import NewMessageBox from './new_message_box/NewMessageBox';

{/* User avatar and markdown box to create new Caregiver Messages   */}
const CorrespondanceNewMessage = (props) => {
  const {
    // props for NewMessageHeader
    corType,
    setCorType,
    sortDir,
    setSortDir,

    // props for NewMessageBox
    caregiverRn,
    caregiverBackend,
  } = props;
  return (
    <Stack
      sx={{
        px: {md: 2.5, xs: 1.5},
        pt: 2,
      }}
    >
      <Stack
        sx={{
          gap: 2,
          pb: 2.5,
        }}
      >
        <NewMessageHeader
          corType={corType}
          setCorType={setCorType}
          sortDir={sortDir}
          setSortDir={setSortDir}
        />
        <NewMessageBox
          caregiverRn={caregiverRn}
          caregiverBackend={caregiverBackend}
        />
      </Stack>
      <Divider sx={{borderColor: '#E8E4DE'}} />
    </Stack>
  );
};
CorrespondanceNewMessage.propTypes = {
  // props for NewMessageHeader
  corType: PropTypes.shape({
    ANNOUNCEMENTS: PropTypes.bool.isRequired,
    COMMENTS: PropTypes.bool.isRequired,
    LOGS: PropTypes.bool.isRequired,
    EMAIL: PropTypes.bool.isRequired,
  }).isRequired,
  setCorType: PropTypes.func.isRequired,
  sortDir: PropTypes.string.isRequired,
  setSortDir: PropTypes.func.isRequired,

  // props for NewMessageBox
  caregiverRn: PropTypes.string.isRequired,
  caregiverBackend: PropTypes.object.isRequired,
};

export default React.memo(CorrespondanceNewMessage);
